<style scoped>
.pdd {
  margin: 40px 80px;
}
</style>

<template lang="pug">
form.pdd
  .row
    #actions.col.s12
      a.btn.indigo.right(@click='approve', v-if='isApplicant || isDisabled') 
        | Approve
        i.material-icons.right check
      a.btn.red.right(@click='disable', v-if='isApproved') 
        | Disable
        i.material-icons.right visibility_off
  .row
    //- pre {{reseller}}
    .col.s12.m6.input-field
      span {{ reseller.account.firstName }}
      label.active(for='name') FirstName :

    .col.s12.m6.input-field
      span {{ reseller.account.lastName }}
      label.active(for='name') LastName :
  .row
    .col.s12.m6.input-field
      span {{ reseller.account.displayName }}
      label.active(for='name') Username :
    .col.s12.m6.input-field
      span {{ reseller.account.email }}
      label.active(for='name') Email :
  .row
    //- .col.s12.m6.input-field
    //-   span {{reseller.account.displayName}}
    //-   label.active(for='name') Birthday :
    .col.s12.m6.input-field
      span {{ reseller.account.phoneNumber }}
      label.active(for='name') Contact :
</template>
<script>
import axios from 'axios'

export default {
  props: ['reseller'],
  resellerData: [],
  computed: {
    isApplicant() {
      return this.reseller.status === 'application'
    },
    isApproved() {
      return this.reseller.status === 'approved'
    },
    isDisabled() {
      return this.reseller.status === 'disabled'
    },
  },
  methods: {
    approve() {
      this.resellerData = {
        id: this.reseller.accountId,
        name:
          this.reseller.account.firstName +
          ' ' +
          this.reseller.account.lastName,
        email: this.reseller.account.email,
      }
      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        axios
          .post(
            `${this.$config.API_URL}/admin/approved-reseller/`,
            this.resellerData,
            {
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
            }
          )
          .then((result) => {
            this.reseller.status = 'approved'
          })
      })
    },
    disable() {
      const id = this.reseller.accountId
      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        axios
          .delete(`${this.$config.API_URL}/admin/disable-reseller/${id}`, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          })
          .then((result) => {
            this.reseller.status = 'disabled'
          })
      })
    },
  },
}
</script>




// WEBPACK FOOTER //
// src/components/app-reseller-details.vue